import { isMobileViewport } from '@/utils/device'

// 存储系统配置信息
const systemStore = {
  namespaced: true,
  state: {
    webSiteInfo: { "loginTypeList": [], "showList": [] },
    loginFlag: false,
    // 账号封禁弹窗开关。服务端返回 code = -12 时置 true
    banFlag: false,
    // 封禁详情（AccountBanVO）：原因、期限、剩余时长、申诉状态等
    banInfo: null,
    // 当前页面是否有更多内容待加载（用于控制 footer 显隐，防止快速滚动时闪现）
    // 默认为 true，避免刷新时底部栏闪现；待数据加载完成后再根据实际情况更新
    pageHasMore: true,
    // 是否移动端视口（<768px）。
    // 初始值同步计算，保证首屏第一帧就用正确的布局分支，避免「桌面结构 → 移动结构」的抖动。
    isMobile: isMobileViewport(),
    // 临时隐藏底部 tab bar。
    // 用于「沉浸式二级页」：比如私信聊天详情，输入框贴在屏幕底部，
    // tab bar 浮在上面会互相遮挡。页面进入时置 true，离开/销毁时必须复位 false。
    hideMobileTabBar: false,
  },
  mutations: {
    setIsMobile (state, newValue) {
      state.isMobile = newValue
    },
    setHideMobileTabBar (state, newValue) {
      state.hideMobileTabBar = newValue
    },
    setWebSiteInfo (state, newValue) {
      state.webSiteInfo = newValue
    },
    setLoginFlag (state, newValue) {
      state.loginFlag = newValue
    },
    setBanFlag (state, newValue) {
      state.banFlag = newValue
    },
    // 展示封禁详情：同时关掉登录框，避免"登录框 + 封禁框"叠在一起
    showBanDialog (state, banInfo) {
      state.banInfo = banInfo || null
      state.banFlag = true
      state.loginFlag = false
    },
    setPageHasMore (state, newValue) {
      state.pageHasMore = newValue
    },
  },
  actions: {

  },
  getters: {
  }
}
export default systemStore